import React, { useState, useEffect } from "react";

import {
    colors,
    Container,
    Grid,
    Hidden,
    makeStyles,
    Paper,
    Slide,
    Typography,
} from "@material-ui/core";

import { uri } from "../../../../help/Api";
import { useHistory } from "react-router-dom";
import {
    useStylesCAB,
    useStylesContainers,
    useStylesDPM,
    useStylesHed,
    useStylesSpDial,
    useStylesUiElemment,
} from "../../../../St/comps/UseStyle";
import clsx from "clsx";
import { insh as inshst } from "../../../../Context/InshSt";
import { useTranslation } from "react-i18next";
import i18next from "i18next";
import moment from "moment";
import axios from "axios";
import { insh, sto, wsto } from "../../../../Context/InshData";
import { useStylesBA } from "../../../../St/comps/UseStyle";
import { getLS } from "../../../../utils/useLS";
import useBreakpoint from "../../../../utils/useBreakpoint";
import toast from "react-hot-toast";
import FoundationsFirstPanel from "./FoundationsFirstPanel";
import FoundationsSecondPanel from "./FoundationsSecondPanel";
import FoundationsThirdPanel from "./FoundationsThirdPanel";
import { getBase64 } from "../../../../services/ImageServices";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Box from "@material-ui/core/Box";
import FoundationsAppbar from "./FoundationsAppbar";
import { branch } from "recompose";
import { GetItemFromOptions } from "../../../../services/global-services";
import FoundationsFourth from "./FoundationsFourth";
const useStyles = makeStyles((theme) => ({
    root: {
        // backgroundColor: theme.palette.background.dark,
        // paddingBottom: theme.spacing(3),
        // direction: "rtl",
        borderColor: colors.red[300],
        minHeight: "100%",
    },
    input: {
        display: "none",
    },
    imageLogo: {
        marginRight: 20,
        marginTop: 5,
        marginBottom: 10,
        textAlign: "center",
    },
    headerTitle: {
        backgroundColor: colors.red[50],
        textAlign: "center",
        fontSize: 20,
        width: "100%",
        fontWeight: "bold",
        marginBottom: "0.5rem"
    },

    allWidth: {
        minWidth: 650,
    },
    checStyl: {
        marginTop: "17px",
        fontSize: "16px",
        padding: "-1px",
    },
    purchTotalCard: {
        backgroundColor: colors.blue[50],
        borderColor: colors.red[300],
    },

}));
function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

function TransitionUp(props) {
    return <Slide {...props} direction="up" />;
}

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        "aria-controls": `simple-tabpanel-${index}`,
    };
}
export default function Foundations(props) {

    // const { AutoOptions, locat, isDialog, DialogClose } = props;
    const { AutoOptions } = props;
    const clasess = useStyles();


    const datas = {
        id: null,
        nameA: "",
        nameE: "",
        FieldA: "",
        FieldE: "",
        bsn_no: "",
        licence_no: "",
        Address: "",
        Tel: "",
        Mobile: "",
        Fax: "",
        Email: "",
        website: "",
        Logo: null,
        Exchangeval: "",
        tax: "",
        port: "",
        tax_no: "",
        BillNotes: "", BillNotes1: "",
        BillNotes2: "",
        BillNotes3: "",
        Disc1_header_ar: "",
        Disc2_header_ar: "",
        Disc3_header_ar: "",
        Disc4_header_ar: "",
        Disc1_header_en: "",
        Disc2_header_en: "",
        Disc3_header_en: "",
        Disc4_header_en: "",
        Disc1_footer_ar: "",
        Disc2_footer_ar: "",
        Disc3_footer_ar: "",
        Disc4_footer_ar: "",
        Disc1_footer_en: "",
        Disc2_footer_en: "",
        Disc3_footer_en: "",
        Disc4_footer_en: "",
        MailBox: "",
        tax_ats: "",
        invval_ats: "",
        actv_elec: "",
        CustDisc: "",
        finyear_date1: "",
        finyear_date2: "",
        showimg: "",
        showvat: "",
        showdisc: "",
        showafterdisc: "",
        showtax: "",
        bank1: "",
        acc1: "",
        bank2: "",
        acc2: "",
        bank3: "",
        acc3: "",
        AddressEn: "",
        chkitemquan: "",
        msg: "",
        offer_type: "",
        VAT_Type: "",
        is_tab3: "",
        tab3val: "",
        consume_type: "",
        img: "",
        cnt: "",
        img2: "",
        contract_no: "",
        activity_name: "",
        city: "",
        branchName: "",
        sales_man: "",
        StartWorkDate: "",
        EndWorkDate: "",
        CStartWorkDate: "",
        CEndWorkDate: "",
        firstAlertDate: "",
        SecondAlertDate: "",
        ThirdAlertDate: "",
        StopWorkingDate: "",
        CStopWorkingDate: "",
        is$sys: "",
        is$$dessys: "",
        is$$$dy: "",
        server_name: "",
        point_name: "",
        status_type: "",
        computer_type: "",
        tax_no_build: "",
        tax_name_street: "",
        tax_name_district: "",
        tax_name_city: "",
        tax_name_country: "",
        tax_zip_code: "",
        tax_additional_address_no: "",
        tax_vat_registration_no: "",
        branch: "",
        footer_img: null,
        header_img: null,

    }
 
    const defBranch = GetItemFromOptions(sto.branchi, AutoOptions.Branches);

    const inshValueAuto = {
        branch: defBranch,
    };

    // const [items, setItems] = useState({
    //     ...SearchActivityReports,
    //     tax_group: AutoOptions.tax_groups[0].id, tax: AutoOptions.tax_groups[0].tax, type: autos_curr.currType[0].id, group_id: AutoOptions.Groupst[0].id,
    //     barcode: AutoOptions.other.barcode, id: AutoOptions.other.lastid, unit: AutoOptions.Units[0].id, subUnits: AutoOptions.Untis,
    // });

    const [params, setParams] = useState({
        ...AutoOptions.Found[0],
        branch: sto.branchi,
    });


    const [valueAutos, setValueAutos] = useState(inshValueAuto);
    const [multiCodeList, setMultiCodeList] = useState([]);
    const point = useBreakpoint();
    const [styl, setStyl] = useState(inshst.custm);
    const [isSearch, setIsSearch] = useState(false);
    const [deleteHeader, setDeleteHeader] = useState(false);
    const [deleteFooter, setDeleteFooter] = useState(false);



    const clsConts = useStylesContainers();
    const clashd = useStylesHed();
    const clasBA = useStylesBA();

    const clasCAB = useStylesCAB();
    const locSto = getLS("sto", {});
    const [loading, setLoading] = useState(insh.LoadAndSucc);
    const [success, setSuccess] = useState(insh.LoadAndSucc);
    const [showPic, setShowPic] = useState(false);
    const [or, setOr] = useState(insh.Or);

    const inshParm = { itake: 20, symple: "", groupSearch: null };
    const [parm, setParm] = useState(inshParm);

    const timer = React.useRef();
    const [uiElement, setUiElement] = useState({});

    const [transition, setTransition] = React.useState(undefined);


    const [currUnitList, setCurrUnitList] = useState([]);
    const [GroupsSubs, setGroupsSubs] = useState([]);

    const [setting, setSetting] = useState({
        screen: "",
        tb: { parms: {}, autos: {} },
    });

    const [style, setStyle] = useState({});

    const buttonClassnameNew = clsx({ [clasCAB.buttonSuccessCAB]: success.new });
    const buttonClassnameSave = clsx({
        [clasCAB.buttonSuccessCAB]: success.save,
    });
    const buttonClassnameDelete = clsx({
        [clasCAB.buttonSuccessCAB]: success.delete,
    });

    const [prevent, setPrevent] = useState(false);

    /* s PMD */
    const [openPMD, setOpenPMD] = useState(false);
    const [barcodeDialogOpen, setBarcodeDialogOpen] = useState(false);
    const [openSearch, setOpenSearch] = useState(false);
    const [openMulti, setOpenMulti] = useState(false);


    const handCloseDw = async () => {
        newToI(1);
        await setOpenPMD(false);
    };
    const handOpenDw = (Transition) => {
        setTransition(() => Transition);
        setOpenPMD(true);
    };
    /* e PMD */




    // const ust_o = (updatedData) => {
    function usto(olddata) { }

    const [dataList, setDataList] = useState([]);

    const changAutos = (prop, newValue) => {
        setValueAutos({ ...valueAutos, [prop]: newValue })
        setParams({
            ...params,
            branch: newValue.id
        });
        reloadGets(newValue, true);
        setPrevent(false);
    };

    const changTField = (prop) => (e) => {
        // console.log(prop+' - '+e.target.value)
        setParams({ ...params, [prop]: e.target.value });
    };


    const ButtonLoading = (prop) => setLoading({ ...loading, [prop]: true });

    const ButtonWitting = (prop) => {

    };
    const [value, setValue] = React.useState(0);
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    const changeHeaderDelete = (prop) => {
        if (deleteHeader) {
            if (AutoOptions.Found[0].header_img != null) {
                setDeleteHeader(!deleteHeader);
                setParams({ ...params, header_img: AutoOptions.Found[0].header_img });
            } else {
                setDeleteHeader(!deleteHeader);
                setParams({ ...params, header_img: null });
            }

        } else {
            setDeleteHeader(!deleteHeader);
            setParams({ ...params, header_img: null });
        }
    }
    const changeFooterDelete = (prop) => {
        if (deleteFooter) {
            if (AutoOptions.Found[0].footer_img != null) {
                setDeleteFooter(!deleteFooter);
                setParams({ ...params, footer_img: AutoOptions.Found[0].footer_img });
            } else {
                setDeleteFooter(!deleteFooter);
                setParams({ ...params, footer_img: null });
            }

        } else {
            setDeleteFooter(!deleteFooter);
            setParams({ ...params, footer_img: null });
        }
    };

    const handleFileInputChange = (e) => {
        let file = null; //= data.Logo;

        file = e.target.files[0];

        getBase64(file)
            .then((result) => {
                file["base64"] = result;
                let n = 23,
                    str;
                if (file.type != "image/jpeg") n = 22;
                str = file.base64.substring(n);
                setParams({
                    ...params,
                    Logo: str,
                });
            })
            .catch((err) => {
            });
    };


    const handleHeaderFileInputChange = (e) => {
        let file = null; //= data.Logo;

        file = e.target.files[0];

        getBase64(file)
            .then((result) => {
                file["base64"] = result;
                let n = 23,
                    str;
                if (file.type != "image/jpeg") n = 22;

                str = file.base64.substring(n);
                // console.log(file.type);

                setParams({
                    ...params,
                    header_img: str,
                    // file
                });
            })
            .catch((err) => {
                // console.log(err);
            });
    };

    const handleFooterFileInputChange = (e) => {
        let file = null; //= data.Logo;

        file = e.target.files[0];

        getBase64(file)
            .then((result) => {
                file["base64"] = result;
                let n = 23,
                    str;
                if (file.type != "image/jpeg") n = 22;

                str = file.base64.substring(n);
                setParams({
                    ...params,
                    footer_img: str,
                });
            })
            .catch((err) => {
            });
    };
    let typeImg = "jpeg";

    const [fileImg, setFileImg] = useState({
        base64URL: "",
        code64: "data:image/" + typeImg + ";base64,",
        code8: "",
        baseURL: false,

        // file:null
    });
    const [fileFooterImg, setFileFooterImg] = useState({
        base64URL: "",
        code64: "data:image/" + typeImg + ";base64,",
        code8: "",
        baseURL: false,

        // file:null
    });


    const [fileHeaderImg, setFileHeaderImg] = useState({
        base64URL: "",
        code64: "data:image/" + typeImg + ";base64,",
        code8: "",
        baseURL: false,

        // file:null
    });

    const ButtonSuccess = (prop, timr) => {
        timer.current = window.setTimeout(() => {
            setLoading({ ...loading, [prop]: false });
            setSuccess({ ...success, [prop]: true });
            if (prop != "save");
        }, timr);
    };


    const newToI = (timr) => {
        ButtonLoading("new");
        ButtonSuccess("new", timr);
        setPrevent(true);
    };


    const [snack, setSnack] = React.useState(insh.Snack);

    const handOSnack = (newState) => {
        setSnack({ openSnak: true, ...newState });
    };
    const handCloseMulti = async (state) => {
        // if (state === "cancle") await restPM(state);
        await setOpenMulti(false);
    };
    const [transitionsmu, setTransitionsmu] = React.useState(undefined);
    function TransitionUp(props) {
        return <Slide {...props} direction="up" />;
    }

    const reloadGets = async (branch, fromBranch) => {
        const tb = {
            wait: true,
            GetFoundation: true,
            parms: {
                iempid: sto.empi,
                branch: branch.id,
            },
        };

        await axios
            .post(uri + "GetD", tb)
            .then((res) => {
                if (fromBranch == true) {
                    if (res.data.Found[0].branch == branch.id) {
                        setParams({
                            ...res.data.Found[0],
                        });
                        setPrevent(false);
                    } else {
                        setParams({
                            ...res.data.Found[0],
                            branch: branch.id,
                        });
                        setPrevent(true);
                    }
                } else {
                    setParams({
                        ...res.data.Found[0],
                        branch: branch.id,
                    });
                    setPrevent(false);
                }
            })
            .catch((error) => {
                setParams({
                    ...datas,
                });
                setPrevent(false);
            });
    };

    const will = () => {
        let ob = "yes";
        if (params.id == "" || params.id == null) {
            ob = "no";
        } else if (params.tax_no == "" || params.tax_no == null) {
            ob = "no";
        } else if (params.nameA == "" || params.nameA == null) {
            ob = "no";
        } else if (params.nameE == "" || params.nameE == null) {
            ob = "no";
        } else if (params.bsn_no == "" || params.bsn_no == null) {
            ob = "no";
        } else if (params.Logo == "" || params.Logo == null) {
            ob = "no";
        } else if (params.Mobile == "" || params.Mobile == null) {
            ob = "no";
        } else if (params.FieldA == "" || params.FieldA == null) {
            ob = "no";
        } else if (params.FieldE == "" || params.FieldE == null) {
            ob = "no";
        } else {
            ob = "yes";
        }
        return ob;
    };

    const addToBS = () => {
        let action = will();

        if (action == "yes") {
            ButtonLoading("save");

            console.log("the curre data is ", params);

            prevent
                ? axios
                    .post(uri + "Foundations", params)
                    .then((res) => {
                        if (res.data) {
                            toast.success("تمت عملية الحفظ بنجاح");
                            reloadGets(valueAutos.branch, false);

                            ButtonSuccess("save", 500);

                        } else {
                            ButtonWitting("save");
                            reloadGets(valueAutos.branch, false);
                            toast.success("تمت عملية الحفظ بنجاح");
                            ButtonSuccess("save", 1000);
                        }
                    })
                    .catch((res) => {
                        toast.error("خطا في عملية الحفظ");
                        reloadGets(valueAutos.branch, false);
                        ButtonSuccess("save", 1000);
                    })
                :
                axios
                    .put(uri + "Foundation", params)
                    .then((res) => {
                        toast.success("تمت عملية التعديل بنجاح");
                        reloadGets(valueAutos.branch, false);
                        ButtonWitting("save");
                        ButtonSuccess("save", 1000);

                    })
                    .catch((res) => {
                        reloadGets(valueAutos.branch, false);
                        ButtonSuccess("save", 1000);
                        toast.error(" لم يتم عملية التعديل ");
                    });
        } else {
            //  toast.error(" لم يتم عملية التعديل ");
            alert("Please...Complete The data ");
        }
    };

    const [confirmDialog, setConfirmDialog] = useState({ isOpen: false });

    const hRowDelete = (id) => {
        // let reResData = [...loadItems];
        // reResData = reResData.filter((t) => t.id !== id);
        // setLoadItems(reResData);
        // setCurrenciesAll(reResData);
        // ButtonSuccess("delete", 1000);
    };

    const deleteToI = async (e, id, screen) => {
        await e.preventDefault();
        setConfirmDialog({ ...confirmDialog, isOpen: false });

        ButtonLoading("delete");
        axios
            .delete(uri + `Foundations?id=${id}`)
            .then((res) => {
                ButtonSuccess("delete", 1000);
                reloadGets(valueAutos.branch, false);
            })
            .catch((err) => {
                alert("لم يتم الحذف");
                // ButtonSuccess("delete", 500);
                ButtonSuccess("delete", 1000);
            });
    };

    // ==== b sd
    const [open, setOpen] = React.useState(false);

    const backHome = () => {
        his.push({ pathname: "/" });
    };
    const back = () => {
        his.goBack();
    };

    const his = useHistory();

    const classes = useStyles();
    const { t } = useTranslation(["forms", "translation"]);

    return (
        <div className={classes.root}>
            {/* <Grid container item xs={12}>
                <Typography
                    size="small"
                    className={classes.headerTitle}
                    color="primary"
                >
                    {"تعريف المؤسسة"}
                </Typography>
            </Grid> */}
            <Typography
                component="div"
                style={{ direction: i18next.language == "ar" ? "rtl" : "ltr" }}
            >

                <Hidden only={["xs"]}>


                    <Container maxWidth={true} style={{ paddingTop: "15px" }}
                    >
                        <Grid
                            container
                            justifyContent="center"
                            lg={12}
                            md={12}
                            sm={12}
                            xs={12}
                        >

                            <div className={clasess.root} style={{ backgroundColor: "fff" }}>
                                <AppBar position="static" style={{ backgroundColor: "fff" }} >
                                    <Tabs
                                        style={{ backgroundColor: colors.red[300] }}
                                        value={value}
                                        onChange={handleChange}
                                        aria-label="simple tabs example"
                                    >
                                        <Tab style={{ fontWeight: "bold" }} label="بيانات الشركة" {...a11yProps(0)} />
                                        <Tab style={{ fontWeight: "bold" }} label="بيانات العنوان الوطني" {...a11yProps(1)} />
                                        <Tab style={{ fontWeight: "bold" }} label="رأس وتذييل الصفحة" {...a11yProps(2)} />
                                    </Tabs>
                                </AppBar>

                                <TabPanel value={value} index={0}>
                                    <b>تعريف المؤسسة</b>


                                    <FoundationsFirstPanel
                                        {...{
                                            AutoOptions,
                                            changTField,
                                            params,
                                            clasess,
                                            handleFileInputChange,
                                            fileImg,
                                            valueAutos,
                                            changAutos
                                        }}
                                    />


                                </TabPanel>

                                <TabPanel value={value} index={1}>
                                    <b>بيانات اضافية</b>
                                    <FoundationsSecondPanel
                                        {...{
                                            AutoOptions,
                                            changTField,
                                            params,
                                            clasess,
                                            handleFileInputChange,
                                            fileImg,
                                            valueAutos,
                                            changAutos
                                        }}
                                    />
                                    <br/>
                                    <br/>
                                    <br/>
                                    <b>الفترة المالية</b>
                                    <FoundationsFourth
                                        {...{
                                            changTField,
                                            params,
                                        }}
                                    />
                                </TabPanel>

                                <TabPanel value={value} index={2}>
                                    <b>رأس وتذييل الصفحة</b>
                                    <Grid item lg={12} md={12} sm={12} xs={12} >

                                        <FoundationsThirdPanel
                                            {...{
                                                changTField,
                                                params,
                                                clasess,
                                                handleHeaderFileInputChange,
                                                handleFooterFileInputChange,
                                                fileHeaderImg,
                                                fileFooterImg,
                                                deleteFooter,
                                                deleteHeader,
                                                changeHeaderDelete,
                                                changeFooterDelete
                                            }}
                                        />
                                    </Grid>

                                </TabPanel>
                            </div>

                        </Grid>
                    </Container>
                </Hidden>
                <Hidden smUp={["sm"]}>
                    <Grid
                        container
                        justifyContent="center"
                        lg={12}
                        md={12}
                        sm={12}
                        xs={12}
                    >

                        <div className={clasess.root} style={{ backgroundColor: "fff" }}>
                            <AppBar position="static" style={{ backgroundColor: "fff" }} >
                                <Tabs
                                    style={{ backgroundColor: colors.red[300] }}
                                    value={value}
                                    onChange={handleChange}
                                    aria-label="simple tabs example"
                                >
                                    <Tab style={{ fontWeight: "bold" }} label="بيانات الشركة" {...a11yProps(0)} />
                                    <Tab style={{ fontWeight: "bold" }} label="بيانات العنوان الوطني" {...a11yProps(1)} />
                                    <Tab style={{ fontWeight: "bold" }} label="رأس وتذييل الصفحة" {...a11yProps(2)} />
                                </Tabs>
                            </AppBar>

                            <TabPanel value={value} index={0}>
                                <b>تعريف المؤسسة</b>


                                <FoundationsFirstPanel
                                    {...{
                                        AutoOptions,
                                        changTField,
                                        params,
                                        clasess,
                                        handleFileInputChange,
                                        fileImg,
                                        valueAutos,
                                        changAutos
                                    }}
                                />


                            </TabPanel>

                            <TabPanel value={value} index={1}>
                                <b>بيانات اضافية</b>
                                <FoundationsSecondPanel
                                    {...{
                                        AutoOptions,
                                        changTField,
                                        params,
                                        clasess,
                                        handleFileInputChange,
                                        fileImg,
                                        valueAutos,
                                        changAutos
                                    }}
                                />

                            </TabPanel>

                            <TabPanel value={value} index={2}>
                                <b>رأس وتذييل الصفحة</b>
                                <Grid item lg={12} md={12} sm={12} xs={12} >

                                    <FoundationsThirdPanel
                                        {...{
                                            changTField,
                                            params,
                                            clasess,
                                            handleHeaderFileInputChange,
                                            handleFooterFileInputChange,
                                            fileHeaderImg,
                                            fileFooterImg,
                                            deleteFooter,
                                            deleteHeader,
                                            changeHeaderDelete,
                                            changeFooterDelete
                                        }}
                                    />
                                </Grid>

                            </TabPanel>
                        </div>

                    </Grid>
                </Hidden>


            </Typography>

            <FoundationsAppbar {...{
                params,
                buttonClassnameNew,
                buttonClassnameSave,
                buttonClassnameDelete,
                clasCAB,
                newToI,
                setting,
                deleteToI,
                addToBS,
                loading,
                clasBA,
                backHome,
                back,
                uiElement,
                prevent
            }}
            />
        </div>
    );
}
